import React from "react";
import { Box } from "@mui/material";
import tokenitizeLogo from "../../Assets/Tokenitize_logo 2.svg";

/**
 * Full brand logo (icon + wordmark + triangle accent above 'z').
 * Always white — uses the official Tokenitize_logo 2.svg.
 */
export default function TokenitizeName({ height = 32, sx = {} }) {
  return (
    <Box
      component="img"
      src={tokenitizeLogo}
      alt="Tokenitize"
      sx={{ height, width: "auto", display: "block", flexShrink: 0, ...sx }}
    />
  );
}
